<template lang="pug">
table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
  thead.thead-light
    tr
      th.text-center(width="5%")
        span #
      th(width="7%")
        span(:title="$t('ui.code')") {{ $t('ui.code') }}
      th(width="7%")
        span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
      th.text-center(width="7%")
        span(:title="$t('ui.redeemed_at')") {{ $t('redeemed_at') }}
  tbody.clusterize-content
    tr(v-if="tbl.length == 0")
      td(colspan="4").text-center
        span {{ $t('message.no_data_available') }}
    tr(v-for="(item, index) in tbl")
      td.text-center
        span(:title="index + 1") {{ index + 1 }}
      td
        span(:title="item.code") {{ item.code }}&nbsp;
      td
        span(:title="item.amount") {{ item.amount }}&nbsp;
      td
        span(v-if="item.redeemed_at" :title="$moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss') }}&nbsp;
    tr.footer
      td.text-right(colspan="2")
        span.d-block {{ $t("ui.sub_total") }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
    tr.footer
      td.text-right(colspan="2")
        span {{ $t("ui.grand_total") }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
</template>

<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalAmount: {
      type: Number,
      default: ""
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalAmount: 0,
    grandTotalAmount: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
        });

        this.grandTotalAmount = this.totalAmount;
      }
    }
  }
};
</script>